import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Spacer, Heading, Text, Box } from "@zillow/constellation";
import { getCommaSeparatedNumber } from "../../utils/zhl-calculator.esm.js";
import { useLastValidDTIValues, getDefaultMortgagePayment } from "./DTICalculator.utils.esm.js";
import { DTIMessage } from "./DTIMessage.esm.js";
import DTISlider from "./DTISlider.esm.js";
import DTICostBreakdownTable from "./DTICostBreakdownTable.esm.js";
const DTIOutputTable = () => {
  const form = useFormContext();
  const lastValidValues = useLastValidDTIValues(form);
  const debtsOut = lastValidValues.calculations.debtsOut;
  const monthlyIncome = lastValidValues.calculations.monthlyIncome;
  const [mortgagePayment, setMortgagePayment] = useState(getDefaultMortgagePayment(debtsOut, monthlyIncome));
  const currentDTI = (mortgagePayment + debtsOut) / monthlyIncome * 100;
  const roundedCurrentDTI = Math.round(currentDTI);
  const onSliderChange = (value) => {
    const newMortgage = value[1] - debtsOut >= 0 ? value[1] - debtsOut : 0;
    setMortgagePayment(newMortgage);
  };
  useEffect(() => {
    setMortgagePayment(getDefaultMortgagePayment(debtsOut, monthlyIncome));
  }, [debtsOut, monthlyIncome]);
  return /* @__PURE__ */ jsxs(Spacer, { margin: "auto", style: {
    textAlign: "center"
  }, children: [
    /* @__PURE__ */ jsxs(Heading, { level: "4", marginBottom: "xs", "aria-live": "polite", "aria-atomic": "true", children: [
      "Debt-to-income ratio",
      /* @__PURE__ */ jsx(Text, { style: {
        display: "block"
      }, fontType: "h4", fontColor: roundedCurrentDTI > 50 ? "orange500" : "green500", marginBottom: "xs", children: Math.round(roundedCurrentDTI) + "%" })
    ] }),
    /* @__PURE__ */ jsxs(Spacer, { paddingBottom: "md", children: [
      /* @__PURE__ */ jsx(Box, { sx: {
        display: "block",
        "@media $sm_lte": {
          display: "none"
        }
      }, children: /* @__PURE__ */ jsx(DTIMessage, { value: roundedCurrentDTI, defaultExpanded: true }) }),
      /* @__PURE__ */ jsx(Box, { sx: {
        display: "block",
        "@media $md": {
          display: "none"
        }
      }, children: /* @__PURE__ */ jsx(DTIMessage, { value: roundedCurrentDTI }) })
    ] }),
    /* @__PURE__ */ jsxs(Box, { sx: {
      "max-width": "315px",
      margin: "$spacing.xl auto auto",
      padding: "0 $spacing.md",
      "@media $md": {
        "max-width": "500px"
      }
    }, children: [
      /* @__PURE__ */ jsx(DTISlider, { monthlyIncome, debtsOut, mortgagePayment, inputValue: getCommaSeparatedNumber(debtsOut + mortgagePayment), onSliderChange }),
      /* @__PURE__ */ jsx(DTICostBreakdownTable, { debtsOut, monthlyIncome, mortgagePayment })
    ] })
  ] });
};
export {
  DTIOutputTable as default
};
